import './SearchResults.less';

import { useEffect, useState } from 'react';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { Container } from 'semantic-ui-react';

import { SEARCH_CONSTANTS } from '../../constants/SearchConstants';

const SearchResults = (props) => {
  const { searchableText, tagBusca, searchSettings } = props;

  const [newSearch, setNewSearch] = useState(true);
  const [onLoadScript, setOnLoadScript] = useState('');

  useEffect(() => {
    setNewSearch(true);
  }, [searchableText, tagBusca]);

  useEffect(() => {
    if (!searchSettings.hasOwnProperty('site_name') || !newSearch) {
      return;
    }
    setNewSearch(false);

    const propsScript = {
      ...SEARCH_CONSTANTS,
      urlBase: searchSettings.url_base,
      urlPortal: searchSettings.site_url,
      portalNome: searchSettings.site_name,
      orgaoId: searchSettings.organ_id,
      textoBusca: searchableText,
      tagBusca: tagBusca,
    };
    setOnLoadScript(`
      document.getElementById('search-results')?.remove();
      new govBrBusca.Busca(
      {
        target: document.getElementById('buscaContainer'),
        props: ${JSON.stringify(propsScript)},
      }
    );`);
  }, [searchSettings, newSearch, searchableText, tagBusca]);
  return (
    <Container>
      <Helmet>
        <script
          id="govbrSearchBundle"
          src={searchSettings.url_bundle}
          onLoad={onLoadScript}
        />
      </Helmet>
      <div id="buscaContainer"></div>
    </Container>
  );
};

export default SearchResults;
